"use strict";
/**
 * モーダル表示
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalDialog = void 0;
/**
 * 開く
 */
const showModal = (dialog) => {
    dialog.showModal();
    requestAnimationFrame(() => {
        dialog.classList.add("is-open");
    });
};
/**
 * 閉じる
 */
const closeModal = (dialog) => {
    dialog.classList.remove("is-open");
    requestAnimationFrame(() => {
        setTimeout(() => {
            dialog.close();
        }, 20);
    });
};
const modalDialog = () => {
    document.querySelectorAll(".js-modal").forEach((modal) => {
        const button = modal.querySelector(".js-modal__button");
        const close = modal.querySelector(".js-modal__close");
        const dialog = modal.querySelector(".js-modal__dialog");
        if (button == null)
            return new Error("unexpected error: .js-modal__button not found.");
        if (close == null)
            return new Error("unexpected error: .js-modal__close not found.");
        if (dialog == null)
            return new Error("unexpected error: .js-modal__dialog not found.");
        button.addEventListener("click", () => {
            showModal(dialog);
        });
        close.addEventListener("click", () => {
            closeModal(dialog);
        });
    });
};
exports.modalDialog = modalDialog;
